import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, PLATFORM_ID, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TenantProfileService } from '../../core/services/tenant-profile.service';
import { whatsappLink } from '../../core/utils/labels';

interface NavChild {
	label: string;
	packageType: string;
}

interface NavItem {
	label: string;
	path: string;
	children?: NavChild[];
}

@Component({
	selector: 'app-header',
	imports: [RouterLink, RouterLinkActive, FaIconComponent],
	templateUrl: './header.html',
})
export class Header {
	private readonly platformId = inject(PLATFORM_ID);

	// Identitas dinamis (fallback environment.brand di service).
	readonly brand = inject(TenantProfileService).brand();
	readonly scrolled = signal(false);
	readonly menuOpen = signal(false);

	readonly nav: NavItem[] = [
		{ label: 'Beranda', path: '/' },
		// Layanan = dropdown (isi sama dgn kolom "Layanan" di footer: filter ?packageType).
		{
			label: 'Layanan',
			path: '/paket',
			children: [
				{ label: 'Paket Umrah', packageType: 'umrah' },
				{ label: 'Paket Haji', packageType: 'hajj' },
				{ label: 'Paket Trip Halal', packageType: 'halal_trip' },
			],
		},
		{ label: 'Blog', path: '/blog' },
		{ label: 'Lacak Booking', path: '/lacak' },
		{ label: 'Hubungi Kami', path: '/hubungi-kami' },
	];

	readonly waLink = whatsappLink(
		this.brand.whatsapp,
		`Halo ${this.brand.name}, saya ingin berkonsultasi tentang paket perjalanan.`,
	);

	@HostListener('window:scroll')
	onScroll(): void {
		if (isPlatformBrowser(this.platformId)) {
			this.scrolled.set(window.scrollY > 12);
		}
	}

	toggleMenu(): void {
		this.menuOpen.update((v) => !v);
	}

	closeMenu(): void {
		this.menuOpen.set(false);
	}
}
